// extracted by mini-css-extract-plugin
export default {"message":"_1LtZM"};